<template>
  <div>
    <footer class="main-footer row mx-0 pt-5 px-3 p-lg-5">
      <div class="col-12 col-lg-10 mx-auto">
        <div
          class="
            d-flex
            flex-lg-row flex-column
            justify-content-center
            align-items-center
            justify-content-lg-between
          "
        >
          <div
            class="
              m-0
              mr-lg-0
              text-center
              d-flex
              align-items-center
              justify-content-center
              flex-lg-row flex-column
              text-lg-left
            "
          >
            <div class="d-flex flex-column">
              <div class="mt-4 mb-1 pt-2">
                <router-link to="/">
                  <img
                    src="@/assets/images/dpsp/logo-m.svg"
                    alt="dpsp Logotipo"
                    style="max-width: 140px"
                  />
                </router-link>
                <ul
                  class="
                    d-flex d-lg-none
                    bdr
                    p-0
                    pb-0
                    mt-2
                    align-items-center
                    justify-content-center
                  "
                >
                  <li class="nav-item">
                    <a
                      href="https://www.linkedin.com/company/grupodpsp"
                      target="_blank"
                      class="mt-4 text-blue-linkedin"
                    >
                      <img src="@/assets/images/dpsp/linkedin.svg" alt="" />
                    </a>
                  </li>
                </ul>
              </div>
              <div class="mb-4 mt-2 pt-2">
                <router-link to="/">
                  <img
                    src="@/assets/images/dpsp/logo-drogaria-pacheco.png"
                    alt="dpsp Logotipo"
                    style="max-width: 170px"
                  />
                </router-link>
                <ul
                  class="
                    bdr
                    d-flex d-lg-none
                    p-0
                    mt-3
                    align-items-center
                    justify-content-center
                  "
                >
                  <li class="nav-item ml-3">
                    <a
                      href="https://www.instagram.com/drogariasaopaulo/"
                      target="_blanck"
                    >
                      <img src="@/assets/images/dpsp/instagram.svg" alt="" />
                    </a>
                  </li>
                  <li class="nav-item ml-3">
                    <a
                      href="https://www.facebook.com/DrogariaSaoPaulo/"
                      target="_blanck"
                    >
                      <img src="@/assets/images/dpsp/facebook.svg" alt="" />
                    </a>
                  </li>
                </ul>
              </div>
              <router-link to="/">
                <img
                  src="@/assets/images/dpsp/logo-drogaria-sp.png"
                  alt="dpsp Logotipo"
                  style="max-width: 170px"
                />
              </router-link>
            </div>
            <div>
              <nav class="navbar navbar-dark mt-0 pl-0 ml-lg-4">
                <div class="d-flex flex-column">
                  <ul
                    class="
                      d-lg-flex d-none
                      bdr
                      p-0
                      mb-4
                      pb-2
                      mt-2 mt-lg-3
                      align-items-start
                      justify-content-start
                    "
                  >
                    <li class="nav-item ml-3">
                      <a
                        href="https://www.linkedin.com/company/grupodpsp"
                        target="_blank"
                        class="mt-4 text-blue-linkedin"
                      >
                        <img src="@/assets/images/dpsp/linkedin.svg" alt="" />
                      </a>
                    </li>
                  </ul>
                  <ul
                    class="
                      d-flex
                      bdr
                      p-0
                      mb-4
                      mt-2 mt-lg-0
                      align-items-center
                      justify-content-center
                    "
                  >
                    <li class="nav-item ml-3">
                      <a
                        href="https://www.instagram.com/drogpacheco/"
                        target="_blanck"
                      >
                        <img src="@/assets/images/dpsp/instagram.svg" alt="" />
                      </a>
                    </li>
                    <li class="nav-item ml-3">
                      <a
                        href="https://www.facebook.com/drogariaspacheco/"
                        target="_blanck"
                      >
                        <img src="@/assets/images/dpsp/facebook.svg" alt="" />
                      </a>
                    </li>
                  </ul>
                  <ul
                    class="
                      bdr
                      d-none d-lg-flex
                      p-0
                      m-0
                      align-items-center
                      justify-content-center
                    "
                  >
                    <li class="nav-item ml-3">
                      <a
                        href="https://www.instagram.com/drogariasaopaulo/"
                        target="_blanck"
                      >
                        <img src="@/assets/images/dpsp/instagram.svg" alt="" />
                      </a>
                    </li>
                    <li class="nav-item ml-3">
                      <a
                        href="https://www.facebook.com/DrogariaSaoPaulo/"
                        target="_blanck"
                      >
                        <img src="@/assets/images/dpsp/facebook.svg" alt="" />
                      </a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>

          <nav class="navbar navbar-dark pl-0">
            <ul class="navbar-nav d-flex align-items-center">
              <li class="nav-item">
                <router-link to="/programas-de-trainee" class="nav-link"
                  >Programa de Trainee</router-link
                >
              </li>
              <li class="nav-item">
                <router-link to="/vagas" class="nav-link">Vagas</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/faq" class="nav-link">FAQ</router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import FacebookIcon from "vue-material-design-icons/Facebook.vue";
import InstagramIcon from "vue-material-design-icons/Instagram.vue";
import LinkedinIcon from "vue-material-design-icons/Linkedin.vue";
import TwitterIcon from "vue-material-design-icons/Twitter.vue";
import PlayIcon from "vue-material-design-icons/Play.vue";

export default {
  name: "MainFooter",

  computed: {
    galeriaTimes() {
      return this.$store.state.teams;
    },
  },

  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    PlayIcon,
  },
};
</script>


<style lang="scss" scoped>
footer {
  background-color: #efefef;
}
.navbar-nav {
  flex-flow: row wrap;
  li {
    margin-left: 4rem;
    a {
      text-decoration: underline;
    }
  }
  @include media-breakpoint-down(sm) {
    flex-direction: column;
    li {
      margin-left: 0rem;
    }
  }
}
.bdr {
  a {
    border-radius: 100px;
    overflow: hidden;
    width: 2.5rem;
    height: 2.5rem;
    display: block;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 100%;
    }
  }
}
li {
  margin: 0px;
  padding: 0px;
}
.nav-link {
  color: #989696 !important;
  padding: 0px !important;
  font-size: 1.4rem;
  font-family: "Nunito";
  margin: 0.2rem 0px;
  &:hover {
    color: theme-color(primary) !important;
  }
}
</style>